import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';

import { Link, Typography } from '@material-ui/core';

// Icons (see https://material-ui.com/components/material-icons/)
import { Email as EmailIcon, Lock as LockIcon } from '@material-ui/icons';

import { yupResolver } from '@hookform/resolvers';

import { useForm } from 'react-hook-form';

import { schemaForgotPassword } from '../../_schema';
import { AmFormButton, AMTextField } from '../../controls';
import { appStyles } from '../../_styles';

const ForgotPassword = () => {
  const classes = appStyles();

  // Use Hook to get history instead of via param.history
  const history = useHistory();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(schemaForgotPassword),
  });

  /**
   *
   * @param {*} login Login object from form. Object has already been verified
   *                  by form. See schemaLogin for object properties.
   */
  const onSubmit = (login: any) => {
    history.push('/forgot-password-sent');
  };

  return (
    <div>
      <LockIcon color="action" style={{ fontSize: 140 }} />
      <Typography variant="h4" component="h1" color="textSecondary">
        Forgot your password?
      </Typography>
      <Typography variant="body1" component="h1" color="textSecondary">
        Don’t worry! We forget things now and then. If your registered with an
        email address, provide it below and we will send you a password reset
        link.
      </Typography>

      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <AMTextField
          name="email"
          control={control}
          errors={errors}
          schema={schemaForgotPassword}
          icon={EmailIcon}
        />

        <AmFormButton>Forgot Password</AmFormButton>

        <Link component={RouterLink} to="/sign-in" variant="body2">
          {'Return to login'}
        </Link>
      </form>
    </div>
  );
};

export { ForgotPassword };
